import { IconProps } from "./Icon.model";

export function Notifications03Icon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.92786 9.27684C3.92789 4.84139 7.54419 1.24988 12 1.24988C16.4558 1.24988 20.0721 4.84142 20.0721 9.27691C20.0722 10.3087 20.1416 11.0873 20.6173 11.7871C20.7984 12.0496 21.1413 12.4935 21.3697 12.8504C21.6255 13.2502 21.8754 13.7323 21.9613 14.2941C22.2416 16.1269 20.9494 17.3135 19.6625 17.8452C15.1298 19.7181 8.87016 19.7181 4.33746 17.8452C3.05056 17.3135 1.75836 16.1269 2.03868 14.2941C2.12459 13.7323 2.37452 13.2502 2.63033 12.8504C2.85873 12.4934 3.20168 12.0495 3.38271 11.7871C3.85838 11.0872 3.92776 10.3085 3.92786 9.27684Z"
        fill={fillColor}
      />
      <path
        d="M14.7776 21.951C13.9742 22.4562 13.0187 22.7476 11.9985 22.7476C10.9782 22.7476 10.0227 22.4562 9.21934 21.951C8.5063 21.5025 8.14977 21.2783 8.27454 20.9056C8.3993 20.5329 8.89126 20.5746 9.87518 20.6581C11.2824 20.7775 12.7146 20.7775 14.1217 20.6581C15.1057 20.5746 15.5976 20.5329 15.7224 20.9056C15.8472 21.2783 15.4906 21.5025 14.7776 21.951Z"
        fill={fillColor}
      />
    </svg>
  );
}
